var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7266_41338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.24245 0 3.1317 2.76867 1.1907 6.78263H22.8092C20.8683 2.76867 16.7575 0 12 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C16.7575 24 20.8683 21.2313 22.8093 17.2174H1.1907C3.1317 21.2313 7.24245 24 12 24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59015 12.5217L12 8.34782L14.4098 12.5217H9.59015Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1304 13.8999L12 15.4651L8.86954 13.8999V11.813H15.1304V13.8999Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9514 8.52689L13.8446 9.63365C14.3167 10.1057 14.6087 10.7579 14.6087 11.4783C14.6087 12.919 13.4407 14.087 12 14.087C10.5593 14.087 9.39134 12.919 9.39134 11.4783C9.39134 10.7579 9.68338 10.1057 10.1555 9.63365L9.04869 8.52689C8.2933 9.28214 7.82614 10.3256 7.82614 11.4783C7.82614 13.7835 9.69486 15.6522 12 15.6522C14.3052 15.6522 16.1739 13.7834 16.1739 11.4783C16.1739 10.3256 15.7067 9.28214 14.9514 8.52689Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7266_41338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/sv.835564caffdfccec3625307f8ab4adee.svg";
export { ForwardRef as ReactComponent };